import { BaseService, Service } from "/@/cool";

@Service("baseLoginLog")
class LoginLog extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
	}
	/**
	 * 分页查询登录日志
	 */
	page(data: any) {
		return this.request({
			url: "/page",
			method: "GET",
			params: data
		});
	}

	/**
	 * 查询登录日志详情
	 */
	info(data: { id: number }) {
		return this.request({
			url: "/info",
			method: "GET",
			params: data
		});
	}
}

export default LoginLog;
